<div class="table-container">
	<nav mat-tab-nav-bar [tabPanel]="tabPanel" [ngClass]="{ border_bottom_hidden: !showTabBars }">
		<ng-container *ngIf="showTabBars">
			<a
				mat-tab-link
				*ngFor="let link of links"
				(click)="changeActiveLink(link)"
				[active]="activeLink === link"
			>
				{{ link }}
			</a>
		</ng-container>
		<div fxFlex="100" fxLayoutAlign="end center">
			<button
				*ngIf="showAddProjectsButton && productsService.PROJECT_CARRIERS"
				(click)="newProjectClicked()"
				color="primary"
				mat-raised-button
			>
				New Project
			</button>
			<button
				*ngIf="showUpdateViewButton && !(activeLink === links[0])"
				class="action-button"
				color="primary"
				[matMenuTriggerFor]="saveView"
				mat-raised-button
			>
				Update View <mat-icon>keyboard_arrow_down</mat-icon>
			</button>
			<button
				*ngIf="showSaveViewButton && activeLink === links[0]"
				class="action-button"
				color="primary"
				[disabled]="!(sortState?.length || filterState?.length)"
				[matMenuTriggerFor]="saveView"
				mat-raised-button
			>
				Save View <mat-icon>keyboard_arrow_down</mat-icon>
			</button>
			<button
				*ngIf="showFilterButton"
				class="action-button"
				color="primary"
				mat-raised-button
				[mtxPopoverTriggerFor]="filterPopover"
				mtxPopoverTriggerOn="click"
			>
				Filter <span>{{ filterState }}</span>
				<mat-icon>keyboard_arrow_down</mat-icon>
			</button>
			<button
				*ngIf="showSortButton"
				class="action-button"
				color="primary"
				mat-raised-button
				[mtxPopoverTriggerFor]="sortPopover"
				mtxPopoverTriggerOn="click"
			>
				Sort <span>{{ sortState }}</span>
				<mat-icon>keyboard_arrow_down</mat-icon>
			</button>
			<button
				*ngIf="showActionButton && actions.length > 1"
				class="action-button"
				color="primary"
				[disabled]="isActionbuttonDisabled && disableActions"
				[matMenuTriggerFor]="menu"
				mat-raised-button
			>
				Actions <mat-icon>keyboard_arrow_down</mat-icon>
			</button>
			<div *ngIf="showActionButton && !isActionbuttonDisabled && !!actionTextDescriptions">
				<div
					class="p-r-1"
					fxLayout="row"
					fxLayoutAlign="end center"
					*ngFor="let actionTextDescription of actionTextDescriptions"
				>
					{{ actionTextDescription }}
				</div>
			</div>
			<button
				*ngIf="showActionButton && actions.length == 1"
				class="focused-button"
				color="primary"
				(click)="firstAction().action(selection.selected)"
				[disabled]="isActionbuttonDisabled && disableActions"
				mat-raised-button
			>
				{{ firstAction().label }}
			</button>
		</div>
	</nav>
	<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>

	<mat-menu #menu="matMenu" xPosition="before">
		<button
			mat-menu-item
			*ngFor="let actionElement of actions"
			(click)="actionElement.action(selection.selected)"
			[disabled]="actionElement.disabled(selection.selected)"
		>
			<span>{{ actionElement.label }}</span>
		</button>
	</mat-menu>

	<mtx-popover
		#filterPopover="mtxPopover"
		[closeOnPanelClick]="false"
		[position]="['below', 'before']"
	>
		<mat-card class="p-0 popover_default_width">
			<mat-card-content>
				<form [formGroup]="filterForm" (keydown.enter)="$event.preventDefault()">
					<div class="p-1 label-text" fxLayout="column">
						<div fxLayout="row" fxLayoutGap="1rem">
							<div fxFlex fxLayoutAlign="end center">
								<span fxFlex fxLayoutAlign="start center"> In this view, show records </span>
							</div>
						</div>
						<div
							class="p-r-1"
							fxFlex
							fxLayoutAlign="center center"
							formArrayName="formArray"
							*ngFor="let field of formArray.controls; let i = index"
						>
							<div [formGroupName]="i" fxFlex fxLayoutAlign="center center">
								<div *ngIf="i === 0" class="p-1" fxFlex fxLayoutAlign="center center">
									<span class="condition-field">Where</span>
								</div>
								<div *ngIf="i === 1" class="p-1" fxFlex fxLayoutAlign="center center">
									<mat-form-field class="condition-field">
										<mat-label>Condition</mat-label>
										<mat-select [(ngModel)]="defaultCondition" formControlName="filterCondition">
											<mat-option [value]="AND">and</mat-option>
											<mat-option [value]="OR">or</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div *ngIf="i > 1" class="p-1" fxFlex fxLayoutAlign="center center">
									<span class="condition-field">{{ defaultCondition }}</span>
								</div>
								<mat-form-field>
									<mat-label>Filter Field</mat-label>
									<input
										type="text"
										placeholder="Filter Field"
										aria-label="Filter Field"
										matInput
										[formControl]="formArray.at(i).get('filterField')"
										[matAutocomplete]="autoFilter"
										#filterTrigger="matAutocompleteTrigger"
										(input)="setFilterTextForInvalidFilterField(formArray.at(i), filterTrigger)"
									/>
									<mat-autocomplete
										autoActiveFirstOption
										#autoFilter="matAutocomplete"
										(optionSelected)="onFilterFieldSelection(i)"
									>
										<mat-option
											class="font-size-12"
											*ngFor="let option of filterOptions[i] | async"
											[value]="option"
										>
											{{ option }}
										</mat-option>
									</mat-autocomplete>
								</mat-form-field>
								<div class="p-1" fxFlex fxLayoutAlign="center center">
									<span *ngIf="!filterFieldsInputTypeMap?.get(field.value?.filterField || '')">
										Contains
									</span>
									<span
										*ngIf="
											filterFieldsInputTypeMap?.get(field.value.filterField || '') === 'usersList'
										"
									>
										In
									</span>
									<span *ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'date'">
										Range
									</span>

									<span
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'customer'"
									>
										Equals
									</span>

									<mat-form-field
										*ngIf="
											filterFieldsInputTypeMap?.get(field.value.filterField) === 'location' ||
											filterFieldsInputTypeMap?.get(field.value.filterField) === 'statesList'
										"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.LOCATION"
												[value]="operator"
											>
												{{ LOCATION_OPERATORS_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'number'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.NUMBER"
												[value]="operator"
											>
												{{ operator }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'volume'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.VOLUME"
												[value]="operator"
											>
												{{ operator }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'string'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.STRING"
												[value]="operator"
											>
												{{ operator }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'stage'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.STAGE"
												[value]="operator"
											>
												{{ STAGE_OPERATORS_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'jobStatus'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.JOB_STATUS"
												[value]="operator"
											>
												{{ JOB_STATUS_OPERATORS_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="
											filterFieldsInputTypeMap?.get(field.value.filterField) ===
											'importStatsJobStatus'
										"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.JOB_STATUS"
												[value]="operator"
											>
												{{ JOB_STATUS_OPERATORS_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'boolean'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.ARCHIVED"
												[value]="operator"
											>
												{{ ARCHIVED_OPERATORS_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'trailerType'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.TRAILER_TYPE"
												[value]="operator"
											>
												{{ EQUAL_NOT_EQUAL_TYPES_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'projectType'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.PROJECT_TYPE"
												[value]="operator"
											>
												{{ EQUAL_NOT_EQUAL_TYPES_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>

								<mat-form-field
									*ngIf="
										!filterFieldsInputTypeMap?.get(field?.value?.filterField || '') ||
										filterFieldsInputTypeMap?.get(field?.value?.filterField || '') === 'string'
									"
								>
									<input
										formControlName="filterText"
										matInput
										name="filter-text"
										placeholder="Filter Text"
										type="text"
									/>
								</mat-form-field>
								<ng-container *ngIf="field?.value?.filterField">
									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'location'"
									>
										<input
											#LocationCtrl="ngModel"
											(setAddress)="setLocationValue($event, field)"
											[(ngModel)]="locationModel[field.value.filterField + i]"
											[ngModelOptions]="{ standalone: true }"
											[allowStateSelection]="true"
											appGoogleLocation
											matInput
											[placeholder]="field.value.filterField"
											type="text"
										/>
									</mat-form-field>
									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'trailerType'"
									>
										<mat-label>Equipments</mat-label>
										<mat-select
											panelClass="customer-select-panel-class"
											disableOptionCentering
											formControlName="filterText"
											multiple
											#trailerType
											(keypress)="trailerTypeKeyPress($event.key, field.value.filterText, i)"
										>
											<div class="mat_select_options_max_height">
												<mat-option *ngFor="let trailer of trailerTypes" [value]="trailer.dbVal">
													{{ trailer.value }}
												</mat-option>
											</div>
											<div fxFlexLayout="row" class="p-0-5">
												<button
													mat-flat-button
													color="primary"
													(click)="trailerType?.close()"
													fxFlex
												>
													Save
												</button>
											</div>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'projectType'"
									>
										<mat-label>Project Type</mat-label>
										<mat-select
											panelClass="customer-select-panel-class"
											disableOptionCentering
											formControlName="filterText"
											multiple
											#projectTypeSelect
										>
											<div class="mat_select_options_max_height">
												<mat-option
													*ngFor="let projectType of PROJECT_TYPES | keyvalue"
													[value]="projectType.value.value"
												>
													{{ projectType.value.label }}
												</mat-option>
											</div>
											<div fxFlexLayout="row" class="p-0-5">
												<button
													mat-flat-button
													color="primary"
													(click)="projectTypeSelect?.close()"
													fxFlex
												>
													Save
												</button>
											</div>
										</mat-select>
									</mat-form-field>

									<div
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'customer'"
									>
										<app-customer-popover
											(setCustomer)="setCustomer($event, field)"
											[customerSelected]="field?.value?.filterText"
										></app-customer-popover>
									</div>

									<div
										*ngIf="
											activeUsersList?.length &&
											filterFieldsInputTypeMap?.get(field.value.filterField) === 'usersList' &&
											activeUsersList.length
										"
									>
										<app-user-selector
											(userChanged)="setAssignedUsersValue($event, field)"
											[multiselect]="true"
											[selectedUsers]="selectedUsers"
											[singleselect]="false"
											[usersList]="activeUsersList"
											customePanelClass="customer-select-panel-class"
											floatLabel="never"
											[placeholder]="usersListPlaceholder"
										></app-user-selector>
									</div>
									<div *ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'date'">
										<app-date-range-selector
											(dateSelected)="dateRangeUpdated($event, field)"
											[previousDateSelector]="showPreviousDates"
											[scorecard]="showScorecardRange"
											class="date-range"
											placeholder="Date"
										>
										</app-date-range-selector>
									</div>

									<div
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'boolean'"
										fxFlex
										fxLayoutAlign="center center"
									>
										<div class="full-width">
											<mat-radio-group
												formControlName="filterText"
												fxFlex
												fxLayout="row"
												fxLayoutGap="1rem"
											>
												<mat-radio-button color="primary" [value]="true">True</mat-radio-button>
												<mat-radio-button color="primary" [value]="false">False</mat-radio-button>
											</mat-radio-group>
										</div>
									</div>

									<ng-container
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'number'"
									>
										<mat-form-field *ngIf="field.value.operator !== OPERATORS.BETWEEN">
											<input
												matInput
												formControlName="filterText"
												autocomplete="off"
												mask="separator"
												thousandSeparator=","
											/>
										</mat-form-field>
										<div fxLayoutGap="1rem" *ngIf="field.value.operator === OPERATORS.BETWEEN">
											<mat-form-field>
												<input
													matInput
													formControlName="startValue"
													autocomplete="off"
													mask="separator"
													thousandSeparator=","
													placeholder="From"
												/>
											</mat-form-field>
											<mat-form-field>
												<input
													matInput
													formControlName="endValue"
													autocomplete="off"
													mask="separator"
													thousandSeparator=","
													placeholder="To"
												/>
											</mat-form-field>
										</div>
									</ng-container>

									<ng-container
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'volume'"
									>
										<div fxLayoutGap="1rem">
											<mat-form-field>
												<mat-label> Load Count </mat-label>
												<input
													matInput
													formControlName="startValue"
													autocomplete="off"
													mask="separator"
													thousandSeparator=","
												/>
											</mat-form-field>
											<mat-form-field *ngIf="field.value.operator === OPERATORS.BETWEEN">
												<mat-label> Load Count </mat-label>
												<input
													matInput
													formControlName="endValue"
													autocomplete="off"
													mask="separator"
													thousandSeparator=","
												/>
											</mat-form-field>
											<mat-form-field fxFlex="100">
												<mat-select formControlName="filterText">
													<mat-option
														*ngFor="let duration of LOAD_VOLUME_DURATION"
														[value]="duration"
													>
														{{ duration }}
													</mat-option>
												</mat-select>
											</mat-form-field>
										</div>
									</ng-container>

									<ng-container
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'statesList'"
									>
										<mat-form-field class="full-width">
											<mat-select
												formControlName="filterText"
												placeholder="Select States"
												multiple
												panelClass="customer-select-panel-class"
												disableOptionCentering
												#statesSelect
											>
												<div class="mat_select_options_max_height">
													<mat-option *ngFor="let state of USA_STATES" [value]="state.value">
														{{ state.label }}
													</mat-option>
												</div>
												<div fxFlexLayout="row" class="p-0-5">
													<button
														mat-flat-button
														color="primary"
														(click)="statesSelect?.close()"
														fxFlex
													>
														Save
													</button>
												</div>
											</mat-select>
										</mat-form-field>
									</ng-container>

									<ng-container
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'stage'"
									>
										<mat-form-field>
											<mat-label>Stage</mat-label>
											<mat-select
												formControlName="filterText"
												multiple
												panelClass="customer-select-panel-class"
												disableOptionCentering
												#stageSelect
											>
												<div class="mat_select_options_max_height">
													<mat-option *ngFor="let stage of PROJECT_STAGES" [value]="stage.type">
														{{ stage.label }}
													</mat-option>
												</div>
												<div fxFlexLayout="row" class="p-0-5">
													<button
														mat-flat-button
														color="primary"
														(click)="stageSelect?.close()"
														fxFlex
													>
														Save
													</button>
												</div>
											</mat-select>
										</mat-form-field>
									</ng-container>

									<ng-container
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'jobStatus'"
									>
										<mat-form-field>
											<mat-label>Job Status</mat-label>
											<mat-select
												formControlName="filterText"
												multiple
												panelClass="customer-select-panel-class"
												disableOptionCentering
												#jobStatusSelect
											>
												<div class="mat_select_options_max_height">
													<mat-option
														*ngFor="let stage of BULK_CAPACITY_MATCH_JOBS_STATUS"
														[value]="stage.type"
													>
														{{ stage.label }}
													</mat-option>
												</div>
												<div fxFlexLayout="row" class="p-0-5">
													<button
														mat-flat-button
														color="primary"
														(click)="jobStatusSelect?.close()"
														fxFlex
													>
														Save
													</button>
												</div>
											</mat-select>
										</mat-form-field>
									</ng-container>

									<ng-container
										*ngIf="
											filterFieldsInputTypeMap?.get(field.value.filterField) ===
											'importStatsJobStatus'
										"
									>
										<mat-form-field>
											<mat-label>Job Status</mat-label>
											<mat-select
												formControlName="filterText"
												multiple
												panelClass="customer-select-panel-class"
												disableOptionCentering
												#importStatsJobStatus
											>
												<div class="mat_select_options_max_height">
													<mat-option
														*ngFor="let stage of IMPORT_STATS_JOBS_STATUS"
														[value]="stage.type"
													>
														{{ stage.label }}
													</mat-option>
												</div>
												<div fxFlexLayout="row" class="p-0-5">
													<button
														mat-flat-button
														color="primary"
														(click)="importStatsJobStatus?.close()"
														fxFlex
													>
														Save
													</button>
												</div>
											</mat-select>
										</mat-form-field>
									</ng-container>
								</ng-container>

								<mat-icon
									(click)="removeFilter(i)"
									class="cursor-pointer"
									*ngIf="formArray.length > 1"
									fxFlex
									fxLayoutAlign="end center"
								>
									delete_forever
								</mat-icon>
							</div>
						</div>
						<div fxLayout="row" fxLayoutGap="1rem">
							<div fxFlex fxLayoutAlign="end center">
								<span
									fxFlex
									fxLayoutAlign="start center"
									class="primary-text label-text-light font-size-16"
								>
									<span
										fxLayout="row"
										(click)="addFilter()"
										class="cursor-pointer"
										*ngIf="isAddConditionActive"
									>
										<mat-icon class="font-size-16">add</mat-icon>
										<span>Add condition</span>
									</span>
									<span fxLayout="row" class="label-text-light" *ngIf="!isAddConditionActive">
										<mat-icon class="font-size-16">add</mat-icon>
										<span>Add condition</span>
									</span>
								</span>
								<span
									fxFlex
									fxLayoutAlign="end center"
									(click)="clearFilters()"
									class="text-underline cursor-pointer m-r-1 font-size-16"
									>Clear filters</span
								>
								<button
									(click)="filterData()"
									color="primary"
									[disabled]="!isFilterButtonActive"
									mat-raised-button
								>
									<span>Filter</span>
								</button>
							</div>
						</div>
					</div>
				</form>
			</mat-card-content>
		</mat-card>
	</mtx-popover>

	<mtx-popover
		#sortPopover="mtxPopover"
		[closeOnPanelClick]="false"
		[position]="['below', 'before']"
	>
		<mat-card class="p-0 popover_default_width">
			<mat-card-content>
				<form [formGroup]="sortForm">
					<div class="p-1 label-text" fxLayout="column">
						<div
							class="p-r-1"
							fxFlex
							fxLayoutAlign="center center"
							formArrayName="sortFormArray"
							*ngFor="let field of sortFormArray.controls; let i = index"
						>
							<div [formGroupName]="i" fxFlex fxLayoutAlign="center center">
								<div *ngIf="i === 0" class="p-1" fxFlex fxLayoutAlign="center center">
									<span class="condition-field">Sort by</span>
								</div>
								<div *ngIf="i > 0" class="p-1" fxFlex fxLayoutAlign="center center">
									<span class="condition-field">then by</span>
								</div>
								<mat-form-field>
									<mat-label>Sort Field</mat-label>
									<input
										type="text"
										placeholder="Sort Field"
										aria-label="Sort Field"
										matInput
										[formControl]="sortFormArray.at(i).get('sortField')"
										[matAutocomplete]="autoSort"
									/>
									<mat-autocomplete autoActiveFirstOption #autoSort="matAutocomplete">
										<mat-option
											class="font-size-12"
											*ngFor="let option of sortOptions[i] | async"
											[value]="option"
										>
											{{ option }}
										</mat-option>
									</mat-autocomplete>
								</mat-form-field>
								<div class="p-1" fxFlex fxLayoutAlign="center center">
									<span>from</span>
								</div>
								<mat-button-toggle-group *ngIf="isNumberField(i)" formControlName="direction">
									<mat-button-toggle [value]="FIRST_TO_LAST">0-9</mat-button-toggle>
									<mat-button-toggle [value]="LAST_TO_FIRST">9-0</mat-button-toggle>
								</mat-button-toggle-group>
								<mat-button-toggle-group *ngIf="!isNumberField(i)" formControlName="direction">
									<mat-button-toggle [value]="FIRST_TO_LAST">First-Last</mat-button-toggle>
									<mat-button-toggle [value]="LAST_TO_FIRST">Last-First</mat-button-toggle>
								</mat-button-toggle-group>
								<mat-icon
									*ngIf="sortFormArray.length > 1"
									(click)="removeSort(i)"
									class="cursor-pointer"
									fxFlex
									fxLayoutAlign="center center"
								>
									delete_forever
								</mat-icon>
							</div>
						</div>
						<div fxLayout="row" fxLayoutGap="1rem">
							<div fxFlex fxLayoutAlign="end center">
								<span
									fxFlex
									fxLayoutAlign="start center"
									class="primary-text label-text-light font-size-16"
								>
									<span
										fxLayout="row"
										(click)="addSort()"
										class="cursor-pointer"
										*ngIf="isAddFieldActive"
									>
										<mat-icon class="font-size-16">add</mat-icon>
										<span>Add field</span>
									</span>
									<span fxLayout="row" class="label-text-light" *ngIf="!isAddFieldActive">
										<mat-icon class="font-size-16">add</mat-icon>
										<span>Add field</span>
									</span>
								</span>
								<span
									fxFlex
									fxLayoutAlign="end center"
									(click)="clearSort()"
									class="text-underline cursor-pointer m-r-1 font-size-16"
									>Clear fields</span
								>
								<button
									(click)="sortData()"
									color="primary"
									[disabled]="!isSortButtonActive"
									mat-raised-button
								>
									<span>Sort</span>
								</button>
							</div>
						</div>
					</div>
				</form>
			</mat-card-content>
		</mat-card>
	</mtx-popover>

	<mat-menu #saveView="matMenu" xPosition="before">
		<button
			mat-menu-item
			*ngFor="let actionElement of saveViewActions"
			(click)="actionElement.action()"
			[disabled]="actionElement.disabled()"
		>
			<span>{{ actionElement.label }}</span>
		</button>
	</mat-menu>

	<div
		class="background-white mat-elevation-z1 primary-border data-container"
		[ngClass]="{ 'loading-cursor': loadingData, 'm-t-0-5': !showTabBars }"
	>
		<div class="p-b-1" *ngIf="dataSource?.data?.length > 0">
			<table [dataSource]="dataSource" class="full-width" mat-table>
				<ng-container matColumnDef="select" *ngIf="rowSelectableEnabled">
					<th *matHeaderCellDef mat-header-cell>
						<mat-checkbox
							*ngIf="selectAllEnabled"
							(change)="$event ? masterToggle() : null"
							[checked]="selection.hasValue() && isAllSelected()"
							[color]="'primary'"
							[disabled]="IS_NULL_OR_UNDEFINED(dataSource) || dataSource?.data?.length === 0"
							[indeterminate]="selection.hasValue() && !isAllSelected()"
						>
						</mat-checkbox>
					</th>
					<td *matCellDef="let row" mat-cell>
						<mat-checkbox
							(change)="$event ? selectRow(row) : null"
							(click)="$event.stopPropagation()"
							[checked]="selection.isSelected(row)"
							[color]="'primary'"
							[disabled]="rowCheckboxIsDisabled && rowCheckboxIsDisabled(row)"
						>
						</mat-checkbox>
					</td>
				</ng-container>

				<ng-container
					[matColumnDef]="column.dataName"
					*ngFor="let column of headers.slice(1); let i = index"
				>
					<th mat-header-cell *matHeaderCellDef>
						<span class="fs-13 font-weight-bold primary-text">{{ column.formattedName }}</span>
					</th>
					<td
						mat-cell
						*matCellDef="let element"
						class="primary-text"
						[ngClass]="{ 'cursor-pointer': column.action }"
						(click)="column.action(element)"
					>
						<div [ngSwitch]="dataTypes[i]">
							<span *ngSwitchCase="'string'">{{ element[column.dataName] }}</span>
							<span *ngSwitchCase="'number'">{{
								element[column.dataName] | number : '1.0-0'
							}}</span>
							<span *ngSwitchCase="'date'">
								{{ element[column.dataName] | date : 'MM/dd/yyyy' }}
							</span>
							<span *ngSwitchCase="'currency'">
								{{ element[column.dataName] / 100 | currency : 'USD' }}
							</span>
							<span *ngSwitchCase="'dateTime'">
								{{ element[column.dataName] | date : 'MM/dd/yyy HH:mm:ss' }}
							</span>
							<mat-checkbox
								*ngSwitchCase="'checkbox'"
								[checked]="!!element[column.dataName]"
								[disabled]="true"
							></mat-checkbox>
							<span *ngSwitchCase="'link'">
								{{ element[column.dataName] }}
							</span>
							<span
								*ngSwitchCase="'userInfo'"
								[mtxPopoverTriggerFor]="userInfoPopover"
								mtxPopoverTriggerOn="hover"
							>
								{{ element.firstName }} {{ element.lastName }}

								<mtx-popover
									#userInfoPopover="mtxPopover"
									[closeOnPanelClick]="false"
									[position]="['below', 'before']"
								>
									<mat-card class="">
										<mat-card-content>
											<div
												fxLayoutAlign="space-between center"
												class="font-size-14"
												*ngIf="element.email"
											>
												Email:
												<a href="mailto:{{ element.email }}" class="m-l-0-5 font-size-14 link">
													{{ element.email }}
												</a>
											</div>

											<div
												fxLayoutAlign="space-between center"
												class="font-size-14 m-t-0-5"
												*ngIf="element.phoneNumber"
											>
												Phone:
												<a href="tel:{{ element.phoneNumber }}">
													{{ element.phoneNumber | mask : '(000) 000-0000' }}
													{{
														IS_NOT_NULL_OR_UNDEFINED(element.phoneNumber.split('ext.')[1])
															? ' ext. ' + element.phoneNumber.split('ext.')[1]
															: ''
													}}
													<br />
												</a>
											</div>
										</mat-card-content>
									</mat-card>
								</mtx-popover>
							</span>
						</div>
					</td>
				</ng-container>

				<tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
				<tr
					*matRowDef="let row; columns: displayedColumns"
					mat-row
					class="{{ rowClasses }}"
					(click)="rowOnClickEnabled ? rowOnClick(row) : null"
				></tr>
			</table>
		</div>
		<div
			*ngIf="dataSource?.data?.length === 0 && !loadingData"
			class="p-b-2"
			fxLayoutAlign="center center"
		>
			No matching {{ dataType }} found.<span *ngIf="filterState.length > 0"
				>&nbsp;Please modify your filter.</span
			>
		</div>

		<div fxLayoutAlign="top center" *ngIf="!!waitingMessage && loadingData">
			<div fxLayoutAlign="end center" fxFlex>
				<mat-spinner class="m-l-1 m-t-1" [diameter]="50" strokeWidth="1"> </mat-spinner>
			</div>
			<div fxLayoutAlign="left center" fxFlex>
				{{ waitingMessage }}
			</div>
		</div>
	</div>

	<div fxLayout="row" fxLayoutAlign="space-between center">
		<div *ngIf="showFooterText && footerText">
			{{ footerText }}
		</div>
		<button
			color="primary"
			*ngIf="showImportProjectsButton && productsService.PROJECT_CARRIERS"
			mat-raised-button
			(click)="importProjectsClicked()"
		>
			Import Projects
		</button>
		<button
			color="primary"
			*ngIf="showImportLoadsButton && productsService.PROJECT_CARRIERS"
			mat-raised-button
			(click)="importLoads({})"
		>
			Import Loads
		</button>
		<button
			color="primary"
			*ngIf="showImportTransactionsButton"
			mat-raised-button
			(click)="importTransactions({})"
		>
			Import Transactions
		</button>
		<button color="primary" *ngIf="showImportRFPButton" mat-raised-button (click)="importRFPs({})">
			Run RFP
		</button>

		<app-upload-carriers
			*ngIf="showImportCarrierButton"
			[text]="'Import Carriers'"
			[useButton]="true"
		></app-upload-carriers>

		<div>
			<mat-paginator
				*ngIf="isStaticData"
				[length]="dataSource?.data?.length"
				[pageSizeOptions]="PAGE_SIZE_OPTIONS"
				showFirstLastButtons
			>
			</mat-paginator>

			<mat-paginator
				*ngIf="!isStaticData"
				(page)="emitPageEvent()"
				[length]="totalNumberOfRecords"
				[pageSizeOptions]="PAGE_SIZE_OPTIONS"
				showFirstLastButtons
			>
			</mat-paginator>
		</div>
	</div>
</div>
